// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomDragPreview_root__eAo32","icon":"CustomDragPreview_icon__PnCCu","label":"CustomDragPreview_label__TL3u4"};